import {FLU_REGIONS} from './fluRegions';
import {RSV_HOSPITALS, RSV_SHANGHAI_SITES} from './rsvRegions';
export const APPOINTMENT_CITIES = ['嘉兴市', '武汉市', '上海市', '青海省'];
export const APPOINTMENT_SITES = {
    RSV: [
        {id: 'rsv-changshui', name: '长水街道社区卫生服务中心', phone: '0573-82870367', address: '浙江省嘉兴市景湖路472号'},
        {id: 'rsv-weitang', name: '魏塘街道社区卫生服务中心', phone: '0573-84469105', address: '浙江省嘉兴市魏塘街道解放东路833号'},
    ],
    FLU: [
        {id: 'flu-weitang', name: '魏塘街道社区卫生服务中心', phone: '18875893380', address: '浙江省嘉兴市魏塘街道解放东路833号'},
        {id: 'flu-xitang', name: '西塘镇卫生院', phone: '0573-89117660'},
        {id: 'flu-fengqiao', name: '凤桥镇中心卫生院', phone: '0573-83628678'},
        {id: 'flu-dongzha', name: '东栅街道社区卫生服务中心', phone: '0573-83389599'},
        {id: 'flu-nanhu', name: '南湖街道社区卫生服务中心', phone: '0573-82851282'},
    ],
};

// Keep registration names in sync with the login catalog; no invented contact details.
export function getAppointmentSites(project, city) {
    if (project === 'RSV' && city === '上海市') return RSV_SHANGHAI_SITES;
    if (city === '嘉兴市') return APPOINTMENT_SITES[project];
    const names = project === 'RSV' ? (RSV_HOSPITALS[city] || [])
        : (FLU_REGIONS.find(r => (r.city || r.province) === city)?.hospitals || []);
    return names.map((name, i) => ({id: `${project.toLowerCase()}-${city === '上海市' ? 'shanghai' : 'qinghai'}-${i + 1}`, name}));
}
